import flag from '../../assets/Flag.png';
import { useSelector } from 'react-redux';

import './userform.css';
import BasicInfo from './BasicInfo';
import OnBoardingForm1 from './OnBoardingForm1';
import OrderHistory from './OrderHistory';
import CurrentSupply from './CurrentSupply';
import WorkingWithUs from './WorkingWithUs';
import ThankYou from './ThankYou';

const BookingInfos = () => {
  const currentPage = useSelector((state) => state.form.currentPage);

  return (
    <section className="tab-container">
      {currentPage === 0 && (
        <div className="tabheadText ">
          <img src={flag} alt="" />
          <p className="text-[#262626]">
            {' '}
            Enter the future of healthcare distribution with{' '}
            <strong className="tabHeadSpan">LifeBank</strong>{' '}
          </p>
        </div>
      )}
      {currentPage === 1 && (
        <div className="tabheadText ">
          <img src={flag} alt="" />
          <p className="text-[#262626]">
            {' '}
            Select products that{' '}
            <strong className="tabHeadSpan">suits your need</strong> the most
          </p>
        </div>
      )}

      {/* {currentPage === 2 && (
        <div className="tabheadText ">
          <img src={flag} alt="" />
          <p className="text-[#262626]">
            {' '}
            Onboarding Information-{' '}
            <strong className="tabHeadSpan">Order History</strong>
          </p>
        </div>
      )} */}

      {/* {currentPage === 3 && (
        <div className="tabheadText ">
          <img src={flag} alt="" />
          <p className="text-[#262626]">
            {' '}
            Onboarding Information-{' '}
            <strong className="tabHeadSpan">Current Supplies</strong>
          </p>
        </div>
      )} */}
      {/* {currentPage === 4 && (
        <div className="tabheadText ">
          <img src={flag} alt="" />
          <p className="text-[#262626]">
            {' '}
            Onboarding Information-{' '}
            <strong className="tabHeadSpan">Working with us</strong>
          </p>
        </div>
      )} */}

      {currentPage === 2 && (
        <div className="tabheadText ">
          <h1 className="text-[3rem] mt-6 font-bold text-[#b70303]">
            THANK YOU
          </h1>
        </div>
      )}

      {currentPage !== 5 && (
        <div className="tablist lg:mb-0 -mb-10 ">
          <div className={`tabHead ${currentPage === 0 ? 'active' : null}`}>
          Personal details
          </div>

          <div
            className={`tabHead ${
              currentPage === 1 ||
              // currentPage === 2 ||
              // currentPage === 3 ||
              currentPage === 4
                ? 'active'
                : null
            }
          `}
          >
            Hospital insights
          </div>
        </div>
      )}

      {/* Basic Information */}
      <section className="w-[100%]">
        <section className="tabContent" hidden={currentPage !== 0}>
          <BasicInfo />
        </section>
        <section className="" hidden={currentPage !== 1}>
          <OnBoardingForm1 />
        </section>

        {/* <section className="tabContent" hidden={currentPage !== 2}>
          <OrderHistory />
        </section>

        <section className="tabContent" hidden={currentPage !== 3}>
          <CurrentSupply />
        </section>
        <section className="tabContent" hidden={currentPage !== 4}>
          <WorkingWithUs />
        </section> */}

        <section className="tabContent" hidden={currentPage !== 2}>
          <ThankYou />
        </section>
      </section>
    </section>
  );
};

export default BookingInfos;
